var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutMomentLg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 60,
  viewBox: "0 0 80 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4 60a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h72a4 4 0 0 1 4 4v52a4 4 0 0 1-4 4zM76 4H4v52h40v-6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v6h8zm-10 8a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H46a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2zM26 32a2 2 0 1 1 0 4H14a2 2 0 1 1 0-4zm8-8a2 2 0 1 1 0 4H14a2 2 0 1 1 0-4z"
})));
export default SvgLayoutMomentLg;